import { action } from 'satcheljs';
export default action('DEACTIVATE_CHARM', function deactivateCharm(charm) {
    return {
        charm: charm,
    };
});
//# sourceMappingURL=deactivateCharm.js.map